module.exports = __webpack_public_path__ + "img/52114125_L.8150291d.png";